var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('div',{staticClass:"h5-content"},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.web_url}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }